import { Injectable } from '@angular/core';
import { CanActivate,  Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, public router: Router) {
  }
  canActivate(): boolean {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
      // sessionStorage.setItem('isLogin', JSON.stringify(false));
      localStorage.setItem('isLogin', JSON.stringify(false));

      return false;
    }
    return true;
  }
}
